module.exports = __webpack_public_path__ + "img/0Q3B7497_Black_MockedUp.f54567b0.jpg";